module.exports = __webpack_public_path__ + "img/mechanical_intensity_icon.c9d99876.png";